import { Fn }		from "ts-base/fn";
import { Either }	from "ts-base/either";

import { FieldSchema, EditorModel, FieldProblem, EditorSchema } from "@v3/geko/form/field";

export type TextSchema	= EditorSchema<TextState>;

export type TextModel	= EditorModel<TextState>;

export type TextState	= string;

//-----------------------------------------------------------------------------
//## simple string

// all strings are valid
export const FreeText	= (initial:string):FieldSchema<TextState, string, string>	=>
	FieldSchema.unrestricted(initial);

//-----------------------------------------------------------------------------
//## restricted string

// NOTE form if we used initial:Maybe<T> here, we could represent types which include null

// "" is a valid null value
export const OptionalText	= <T>(companion:Companion<T>) => (initial:T|null):FieldSchema<TextState, T|null, T|null>	=>
	FieldSchema.of({
		initial:	initial,
		required:	false,
		restricted:	true,
		parse:		(value) => value === "" ? Either.right(null) : FieldProblem.nullIsInvalid(companion.fromString(value)),
		unparse:	(initial) => initial !== null ? companion.toString(initial) : "",
	});

// "" is an invalid not-yet-set value
export const RequiredText	= <T>(companion:Companion<T>) => (initial:T|null):FieldSchema<TextState, T, T|null>	=>
	FieldSchema.of({
		initial:	initial,
		required:	true,
		restricted:	true,
		parse:		(value) => value === "" ? Either.left("missing") : FieldProblem.nullIsInvalid(companion.fromString(value)),
		unparse:	(initial) => initial !== null ? companion.toString(initial) : "",
	});

export type Companion<T>	= {
	fromString:	Fn<string, T|null>,
	toString:	Fn<T, string>,
};
